import moment from 'moment';

export const formatTime = (timestamp: number) => {
  return moment.unix(timestamp).format('HH:mm');
};
